var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.href}},[_vm._v(_vm._s(_vm.$mq == 'sm' ? 'DL' : 'Download')+" Data")])])}
var staticRenderFns = []

export { render, staticRenderFns }